import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/de";
import "dayjs/locale/en";

import { maxItemsProps } from "@/components/DoughnutChart/types";

import { QrCodeResponse } from "@/interface/api/getAllQrCodes/types";

import { ApiErrorMessageBuilder } from "./apiErrorHandler";

import { EditButtonProps } from "./types";
import { TFunction } from "i18next";

export const onEditButton = ({
  id,
  requestQrCode,
  navigateFromQrToEditor,
  qrCodeEditor,
  router,
  toast,
}: EditButtonProps) => {
  if (id) {
    requestQrCode({ qrId: id })
      .then(({ data }) => {
        const formattedData = data as QrCodeResponse;
        navigateFromQrToEditor(qrCodeEditor, formattedData, router);
      })
      .catch((error) => {
        const errorMessage = ApiErrorMessageBuilder.buildToastMessage(error);
        toast({ message: errorMessage, type: "error" });
      });
  }
};

export const getFormattedDate = (date: string, locale: string = "en") => {
  dayjs.extend(localizedFormat);
  const lang = locale.split("-")[0];

  return dayjs(date).locale(lang).format("ll");
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "paused":
      return "warning";
    case "draft":
      return "inactive";
    case "active":
      return "success";
    default:
      return "primary";
  }
};

export const getStatusLabel = (status: string, t: TFunction) => {
  //Translations keys in status.json file
  switch (status) {
    case "paused":
      return t("paused_status");
    case "draft":
      return t("draft_status");
    case "active":
      return t("active_status");
    default:
      return t("");
  }
};

export const isFramedQr = (qrAi, style) => !qrAi && style.frameStyle && style.frameStyle !== "none";

export const SHARED_PROPS: {
  collectionColors: string[];
  maxItemsNumber: maxItemsProps;
} = {
  collectionColors: [
    "#2DCB91",
    "#FF6569",
    "#6AF0FF",
    "#FFCB51",
    "#AC4DCC",
    "#FF70DF",
    "#235BF3",
    "#FF9F0F",
    "#058797",
    "#A2E512",
  ],
  maxItemsNumber: {
    itemsNumber: 10,
    remainingItemsLabel: "Others",
    legendColor: "#A7E4E3",
  },
};
